import Brand from './Brand';
import { Icon } from './JournalOverview';
import { GuideDialog } from './JournalGuide';
import './release-notes.css';

export default function WhatsNewDialog({ release, onClose, onPatchNotes }) {
  return <GuideDialog label="What's new in TradeLog" onClose={onClose} className="tl-whats-new">
    <header className="tl-whats-new-header"><Brand size={20}/><span className="tl-whats-new-version">v{release.version}</span><button className="tl-icon-button" data-guide-close aria-label="Close release update" onClick={onClose}><Icon name="close" size={18}/></button></header>
    <div className="tl-whats-new-content" role="region" aria-label="Release details" tabIndex={0}>
      <span className="tl-eyebrow">WHAT’S NEW · {release.date}</span>
      <h1>{release.title || 'Your journal, refined.'}</h1>
      {release.description && <p className="tl-whats-new-intro">{release.description}</p>}
      <ul className="tl-release-entries">{(release.updates || []).map((update, index) => {
        const divider = update.indexOf(' — ');
        return <li key={index}><span className="tl-release-bullet" aria-hidden="true"/><p>{divider > 0 ? <><strong>{update.slice(0, divider)}</strong>{update.slice(divider)}</> : update}</p></li>;
      })}</ul>
    </div>
    <footer className="tl-whats-new-footer"><button className="tl-btn tl-btn-primary" onClick={onClose}>Back to journal<Icon name="arrow" size={16}/></button><button className="tl-text-button" onClick={() => { onClose(); onPatchNotes(); }}>View full release notes</button></footer>
  </GuideDialog>;
}
